import { render } from "./home.vue?vue&type=template&id=53dead42"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=53dead42&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__